/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerComplianceBlockingEventTimelinePayload
 */
export interface FreelancerComplianceBlockingEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceBlockingEventTimelinePayload
     */
    authorId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceBlockingEventTimelinePayload
     */
    authorFullName: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceBlockingEventTimelinePayload
     */
    reason: string;
}

/**
 * Check if a given object implements the FreelancerComplianceBlockingEventTimelinePayload interface.
 */
export function instanceOfFreelancerComplianceBlockingEventTimelinePayload(value: object): value is FreelancerComplianceBlockingEventTimelinePayload {
    if (!('authorId' in value) || value['authorId'] === undefined) return false;
    if (!('authorFullName' in value) || value['authorFullName'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function FreelancerComplianceBlockingEventTimelinePayloadFromJSON(json: any): FreelancerComplianceBlockingEventTimelinePayload {
    return FreelancerComplianceBlockingEventTimelinePayloadFromJSONTyped(json, false);
}

export function FreelancerComplianceBlockingEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerComplianceBlockingEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'authorId': json['authorId'],
        'authorFullName': json['authorFullName'],
        'reason': json['reason'],
    };
}

export function FreelancerComplianceBlockingEventTimelinePayloadToJSON(value?: FreelancerComplianceBlockingEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'authorId': value['authorId'],
        'authorFullName': value['authorFullName'],
        'reason': value['reason'],
    };
}

